import React from 'react'

interface Props { }

interface State { }

export class Footer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
  }

  public render() {
    return (
      <>
        <hr />
        <div className="text-center text-muted mb-4">
          Copyright &copy;
          <a href="https://www.ideamans.com/">ideaman's Inc.</a>
        </div>
      </>
    )
  }
}